export function isEmptySortValue(value) {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (
      typeof value === "number" &&
      Number.isNaN(value)
    )
  );
}

export function getSortValue(
  row,
  field,
  accessors = {}
) {
  const accessor = accessors[field];

  if (typeof accessor === "function") {
    return accessor(row);
  }

  return String(field || "")
    .split(".")
    .reduce(
      (value, key) =>
        value === null ||
        value === undefined
          ? undefined
          : value[key],
      row
    );
}

export function compareSortValues(
  first,
  second,
  sortOrder = "asc"
) {
  const firstEmpty =
    isEmptySortValue(first);

  const secondEmpty =
    isEmptySortValue(second);

  if (firstEmpty && secondEmpty) return 0;
  if (firstEmpty) return 1;
  if (secondEmpty) return -1;

  let result = 0;

  if (
    typeof first === "number" &&
    typeof second === "number"
  ) {
    result = first - second;
  } else if (
    typeof first === "boolean" &&
    typeof second === "boolean"
  ) {
    result =
      Number(first) - Number(second);
  } else {
    result = String(first).localeCompare(
      String(second),
      "fr",
      {
        numeric: true,
        sensitivity: "base",
      }
    );
  }

  return sortOrder === "desc"
    ? -result
    : result;
}

export function sortRows(
  rows,
  {
    sortBy,
    sortOrder = "asc",
    accessors = {},
  }
) {
  if (!Array.isArray(rows)) return [];
  if (!sortBy) return [...rows];

  return rows
    .map((row, originalIndex) => ({
      row,
      originalIndex,
    }))
    .sort((first, second) => {
      const result = compareSortValues(
        getSortValue(
          first.row,
          sortBy,
          accessors
        ),
        getSortValue(
          second.row,
          sortBy,
          accessors
        ),
        sortOrder
      );

      if (result !== 0) {
        return result;
      }

      return (
        first.originalIndex -
        second.originalIndex
      );
    })
    .map(({ row }) => row);
}
